import React from 'react';
import PageHeader from '../components/PageHeader';
import { BarChartComponent, LineChartComponent, PieChartComponent } from '../components/CustomChart';
import { analyticsData } from '../data/dummyData';

const Analytics = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Analytics"
        description="Track your business performance"
        breadcrumbs={['Home', 'Analytics']}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <LineChartComponent
          data={analyticsData.monthlySales}
          dataKey="revenue"
          title="Revenue Trend"
          xAxisKey="month"
        />
        <BarChartComponent
          data={analyticsData.categoryRevenue}
          dataKey="revenue"
          title="Revenue by Category"
          xAxisKey="category"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PieChartComponent
          data={analyticsData.orderStatus}
          dataKey="value"
          title="Order Distribution"
        />
        <LineChartComponent
          data={analyticsData.customerGrowth}
          dataKey="customers"
          title="Customer Growth"
          xAxisKey="month"
        />
      </div>
    </div>
  );
};

export default Analytics;
